export const ACTIONS = {
  CREATE: 'create',
  DELETE: 'delete',
  UPDATE: 'update',
  SAVE: 'save',
};
